<script setup lang="ts">
import ArchiveTaskTable from "@/components/archive/ArchiveTaskTable.vue";
import ConfigSection from "@/layouts/content/ConfigSection.vue";
import { useRouteParams } from "@vueuse/router";

const { t } = useI18n();

const siteId = useRouteParams<string>("id");
</script>

<template>
	<ConfigSection :title="t('archive.header')" :description="t('archive.caption')">
		<ArchiveTaskTable :siteId="siteId" />
	</ConfigSection>
</template>
